import React, { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import _replace from 'lodash/replace';
import IconButton, {
  IconButtonTypes,
} from '@lib/components/IconButton/IconButton';
import { Values } from '@lib/interfaces/form';
import {
  FormTemplateQuestionFieldOptionGroupEnum,
  FormTemplateQuestionFieldsKindEnum,
} from 'graphql-common';
import FormTemplateFieldNames from '@lib/enums/fieldNames/formTemplateFieldNames';
import removeValidityHintConfigItem from './utils/removeValidityHintConfigItem';
import styles from './QuestionFieldOption.module.scss';

interface Props {
  kind: FormTemplateQuestionFieldsKindEnum;
  validityHintConfig: Values;
  onRemove: () => void;
  parentIndex: number;
  parentName: string;
  parentValue: Values[];
}

const getDeleteBtnIcon = (kind: FormTemplateQuestionFieldsKindEnum) => {
  if (
    kind === FormTemplateQuestionFieldsKindEnum.CheckboxButtonGrid ||
    kind === FormTemplateQuestionFieldsKindEnum.Checklist
  ) {
    return 'cancel';
  }
  return 'close';
};

const getClassName = (kind: FormTemplateQuestionFieldsKindEnum) => {
  if (kind === FormTemplateQuestionFieldsKindEnum.Checklist) {
    return styles.optionDeleteBtnForChecklist;
  }
  return styles.optionDeleteBtn;
};

export default function QuestionFieldOptionDeleteBtn(props: Props) {
  const {
    kind,
    validityHintConfig,
    onRemove,
    parentIndex,
    parentName,
    parentValue,
  } = props;
  const { setValue } = useFormContext();

  const icon = getDeleteBtnIcon(kind);
  const className = getClassName(kind);

  const onRemoveHandler = useCallback(() => {
    if (validityHintConfig) {
      const deletedOption = parentValue[parentIndex];
      const deletedOptionGroup =
        deletedOption.group as FormTemplateQuestionFieldOptionGroupEnum;
      const deletedOptionPosition = deletedOption.position as number;
      const newValidityHintConfig = removeValidityHintConfigItem(
        deletedOptionPosition,
        deletedOptionGroup,
        validityHintConfig,
      );
      setValue(
        _replace(
          parentName,
          `.${FormTemplateFieldNames.Options}`,
          `.${FormTemplateFieldNames.ValidityHintConfig}`,
        ),
        newValidityHintConfig,
      );
    }
    onRemove();
  }, [
    onRemove,
    parentIndex,
    parentName,
    parentValue,
    setValue,
    validityHintConfig,
  ]);

  return (
    <IconButton
      icon={icon}
      rounded
      type={IconButtonTypes.TertiaryFilled}
      onClick={onRemoveHandler}
      className={className}
    />
  );
}
